import { useAppState } from 'hooks/useAppState';

export const useUsersEditorState = () => {
  const { usersEditorState } = useAppState();

  return usersEditorState;
};
